import { useEffect, useRef, useState } from "react";
import { GenericComponent } from "../../../components/GenericComponent";
import { Generico } from "../../../components/Generico";
import { Accionista } from "../../../models/fun/Accionista";
import { useToken } from "../../../components/useToken";
import { FileComponent } from "../../../components/FileComponent";
import { InputComponent } from "../../../components/InputComponent";
import { FuncionarioService } from "../../../service/ficha/FuncionarioService";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import { Card } from "primereact/card";
import { Panel } from "primereact/panel";
import { Divider } from "primereact/divider";
import { TabPanel, TabView } from "primereact/tabview";
import { DatosAccGeneral } from "./DatosAccGeneral";
import { ConyugueAccionista } from "./ConyugueAccionista";
import { InformacionLaboralAccionista } from "./InformacionLaboralAccionista";
import { FinancieraAccionista } from "./FinancieraAccionista";
import { AmpliadaAccionsista } from "./AmpliadaAccionista";
import { FormPep } from "../FormPep";
import { Dialog } from "primereact/dialog";
import { FileBvg } from "../../../components/FileBvg";
import { Cancelar } from "../Cancelar";
import { VinculacionBvg } from "./VinculacionBvg";

export const AccionistaPnBvg = () => {

    const generic = new GenericComponent();
    const omodel = new Accionista();
    const { accionesTbl } = Generico();
    const [registros, setRegistros] = useState(null);
    const [catalogos, setCatalogos] = useState(null);
    const [accionista, setAccionista] = useState(null);
    const [activeIndex, setActiveIndex] = useState(0);
    const [permss, setPermss] = useState(null);
    const [siCliente, setSiCliente] = useState(false);
    const [dialogCliente, setDialogCliente] = useState(false);
    const toast = useRef(null);
    const accSrv = new FuncionarioService();
    const [urls, setUrls] = useState(null);
    const [urlsPep, setUrlsPep] = useState(null);
    const { getPerss, getRol, getInfo, removeKey } = useToken();
    const [hayPep, setHayPep] = useState(false);
    const [pepEstado, setPepEstado] = useState(null);
    const [dialogSubir, setDialogSubir] = useState(false);
    const [dialogPep, setDialogPep] = useState(false);
    const [fpendiente, setFpendiente] = useState(null);
    const [estados, setEstados] = useState(null);
    const [opcion, setOpcion] = useState(null);
    const [dialogCancelar, setDialogCancelar] = useState(false);
    const filters = [fpendiente, estados];
    const [hayTercero, setHayTercero] = useState(false);
    const [vinEstado, setVinEstado] = useState(null);
    const [urlsVin, setUrlsVin] = useState(null);
    const [dialogVinculacion, setDialogVinculacion] = useState(false);
    const { dialogInstruccion, setdialogIns } = FileComponent({ generic, toast, permss, id: accionista?.id });
    const { table, setLoading, setTotalRecords, lazyParams } = InputComponent({ registers: registros, omodel, generic, permss, id: accionista?.id, filters });

    useEffect(() => {
        setUrls({
            urlListado: 'ficha/accionista-pn-bvg',
            urlDownload: 'ficha/accionista-pn-bvg/descarga',
            urlUpload: 'ficha/accionista-pn-bvg/store',
            udelete: 'ficha/accionista-pn-bvg/eliminar-anexo',
            uactual: 'ficha/accionista-pn-bvg/editar',
            uenviar: 'ficha/accionista-pn-bvg/enviar',
            uaprobar: 'ficha/accionista-pn-bvg/aprobar',
            urlGenerar: 'ficha/accionista-pn-bvg/generar-consulta',
        });
        setUrlsPep({
            urlListado: 'ficha/pep-ficha',
            urlDownload: 'ficha/pep-ficha/descarga',
            urlUpload: 'ficha/pep-ficha/store',
            urlVerificacion: 'ficha/pep-ficha',
            udelete: 'ficha/pep-ficha/eliminar-anexo',
            uactual: 'ficha/pep-ficha/editar',
            uenviar: 'ficha/pep-ficha/enviar',
            uaprobar: 'ficha/pep-ficha/aprobar',
            urlGenerar: 'ficha/pep-ficha/generar-consulta',
        });
        setUrlsVin({
            urlListado: 'ficha/vinculacion',
            urlDownload: 'ficha/vinculacion/descarga',
            urlUpload: 'ficha/vinculacion/store',
            udelete: 'ficha/vinculacion/eliminar-anexo',
            uactual: 'ficha/vinculacion/editar',
            uenviar: 'ficha/vinculacion/enviar',
            uaprobar: 'ficha/vinculacion/aprobar',
        });
        setSiCliente(getPerss() !== undefined);

        if (getPerss() === undefined) {
            loadLazyData();
        }
        else {
            setPermss(getPerss());
            if (getInfo('oid')) {
                confirmCarga();
            } else {
                editFicha(false);
            }
        }
    }, [lazyParams]);

    const confirmCarga = () => {
        const message = 'Se ha detectado un formulario anterior ingresado, ¿Quiere recuperar la información?';
        confirmDialog({
            message: message,
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            style: { maxWidth: '400px' },
            accept: () => editFicha(true),
            reject: () => {
                removeKey('oid');
                editFicha(false);
            }
        });
    }

    const loadLazyData = () => {
        setLoading(true);

        let _lazyParams = lazyParams;
        delete _lazyParams.rtipo;
        if (permss == null) {
            _lazyParams.rtipo = true;
        }
        if (getRol()) {
            _lazyParams.rol = getRol();
        }
        accSrv.listado({ lazyEvent: JSON.stringify(_lazyParams) }, 'accionista-pn-bvg').then(res => {
            setTotalRecords(res.data.total);
            setRegistros(res.data.registros);
            setLoading(false);
            if (res.data.perss !== undefined) {
                setPermss(res.data.perss);
                setOpcion(res.data.opcion);
            }
            if (res.data.cats) {
                setCatalogos(res.data.cats);
                setFpendiente(res.data.cats.pendiente);
                setEstados(res.data.cats.estados);
            }
        });
    }

    const openNew = () => {
        setDialogCliente(true);
        setAccionista(null);
        setdialogIns(true);
        setPepEstado(null);
        setHayPep(false);
        setHayTercero(false);
    }

    const confirmDelete = (siDelete = true) => {
        const message = siDelete ? '¿Está seguro de eliminar el formulario?' : '¿Está seguro de cancelar el formulario? No podrá reveresar este cambio.';
        confirmDialog({
            message: message,
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => siDelete ? deleteCliente() : setDialogCancelar(true)
        });
    }

    const deleteCliente = () => {
        accSrv.eliminar(accionista?.id, 'accionista-pn-bvg', accionista?.id).then(res => {
            if (!siCliente) {
                loadLazyData();
            }
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        });
    }

    const nuevoCliente = (nuevo) => {
        const _acc = accionista ?? {};
        if (nuevo) {
            if (nuevo?.id !== undefined) _acc.id = nuevo.id;
            if (nuevo?.estado_acc !== undefined) _acc.estado_acc = nuevo.estado_acc;
            // Pep
            if (nuevo?.pid !== undefined) _acc.pid = nuevo.pid;
            if (nuevo?.hay_pep !== undefined) _acc.hay_pep = nuevo.hay_pep;
            if (nuevo?.estado_pep !== undefined) setPepEstado(nuevo.estado_pep);
            // Vinculación terceros
            if (nuevo?.vid !== undefined) _acc.vid = nuevo.vid;
            if (nuevo?.hay_tercero !== undefined) _acc.hay_tercero = nuevo.hay_tercero;
            if (nuevo?.estado_tercero !== undefined) setVinEstado(nuevo.estado_tercero);
        }
        setHayPep(_acc.hay_pep === true);
        setHayTercero(_acc.hay_tercero === true);
        // Si accionista es null, y al procesar las propiedades, tenemos {}, asignamos null en vez de {}
        setAccionista(Object.keys(_acc).length === 0 ? null : _acc);
    }

    const editFicha = (cargar = false) => {
        if (catalogos === null) {
            accSrv.nuevo({ iniciar: 1, cargar: cargar }, 'accionista-pn-bvg').then(res => {
                setCatalogos(res.data.cats);
                setDialogCliente(true);
                setAccionista(null);
                setActiveIndex(0);
                setdialogIns(true);
                if (res.data.codigo) {
                    nuevoCliente({
                        id: res.data.codigo,
                        estado_acc: res.data.estado_acc,
                        hay_pep: res.data.hay_pep,
                        pid: res.data.pid,
                        estado_pep: res.data.estado_pep,
                        hay_tercero: res.data.hay_tercero,
                        vid: res.data.vid,
                        estado_tercero: res.data.estado_tercero
                    });
                }
            }).finally(() => {
                setLoading(false);
                if (getInfo('oid')) {
                    removeKey('oid');
                    confirmacion();
                }
            });;
        }
        else {
            setDialogCliente(true);
            setActiveIndex(0);
            setdialogIns(true);
        }
    }

    const confirmacion = () => {
        const message = omodel.confirmacionBVG;
        confirmDialog({
            message: message,
            header: 'Declaración',
            icon: 'pi pi-info-circle',
            acceptLabel: 'Aceptar',
            style: { maxWidth: '400px' },
            accept: () => { },
            footer: (options) => {
                return (
                    <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                        <Button label="Aceptar" icon="pi pi-check" onClick={options.accept} autoFocus />
                    </div>
                );
            }
        });
    }

    const nextPrev = (btn = true) => {
        const btnNext = btn ? <Button label="Siguiente" type="submit" icon="pi pi-chevron-right" /> :
            <Button label="Siguiente" type="button" icon="pi pi-chevron-right" onClick={e => { handleNext(); }} />;
        return (
            <div className="formgrid grid">
                <div className="field col">
                    <Button label="Anterior" icon="pi pi-chevron-left" type="button" onClick={e => handlePrev()} />&nbsp;
                    {btnNext}
                </div>
            </div>
        )
    }

    const handleNext = () => {
        if (activeIndex < 7) {
            setActiveIndex(activeIndex + 1);
        }
    };

    const handlePrev = () => {
        if (activeIndex > 0) {
            setActiveIndex(activeIndex - 1);
        }
    }

    const siOpcion = (strOpcion) => {
        return permss?.actualizar && (opcion === 'PRELAFIT' || opcion.includes(strOpcion));
    }

    const itemsMenu = () => {
        const items = [];
        if (permss?.actualizar && ['BORRADOR', 'ENVIADO'].includes(accionista?.estado_acc))
            items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => { editFicha() } });
        if (permss?.consultar) items.push({ label: 'Anexos formulario', icon: 'pi pi-clone', command: () => { setDialogSubir(true) } });
        if (permss?.consultar && accionista?.pid)
            items.push({ label: 'Anexos formulario(PEP)', icon: 'pi pi-reddit', command: () => { setDialogPep(true) } });
        if (permss?.consultar && accionista?.vid)
            items.push({ label: 'Anexos formulario - Vinculación', icon: 'pi pi-discord', command: () => { setDialogVinculacion(true) } });
        if (siOpcion('form-accionista-bvg-cancelar') && ['BORRADOR'].includes(accionista?.estado_acc))
            items.push({ label: 'Cancelar formulario', icon: 'pi pi-lock', command: () => { confirmDelete(false) } });
        if (permss?.eliminar && ['BORRADOR', 'ENVIADO'].includes(accionista?.estado_acc))
            items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => { confirmDelete() } });

        return [{ label: 'Opciones', items: items }];
    }

    const regresar = () => {
        setActiveIndex(0);
        setDialogCliente(false);
        if (!siCliente) {
            loadLazyData();
        }
    }

    const reiniciar = () => {
        if (!siCliente) {
            loadLazyData();
        }
        setDialogCliente(false);
        setDialogPep(false);
        setDialogSubir(false);
        setDialogVinculacion(false);
    }

    const reiniciarPep = (ban) => {
        setActiveIndex(4);
        if (ban && ban === 'ENVIADO') {
            setPepEstado('ENVIADO');
        }
    }

    const respuesta = () => {
        setDialogCancelar(false);
        loadLazyData();
    }

    const reiniciarVinculacion = (est) => {
        if (!siCliente) {
            loadLazyData();
        }
        setActiveIndex(4);
        nuevoCliente({ estado_tercero: est });
    }

    return (
        <>
            <ConfirmDialog />
            <Toast ref={toast} />
            {!dialogCliente && !siCliente && <Toolbar className="mb-4" start={generic.leftToolbarTemplate(openNew, 'Nuevo', permss)}
                end={generic.rightToolbarTemplate(registros, omodel, 'Reporte_accionista', 'LISTADO ACCIONISTA PERSONA NATURAL')}></Toolbar>}
            {!dialogCliente && !siCliente && <Card style={{ maxWidth: '100%', margin: 'auto' }}>
                {table({ action01: accionesTbl, reg: setAccionista, items: itemsMenu() })}
            </Card>}

            {dialogCliente &&
                <Panel header='FORMULARIO POLÍTICA CONOZCA A SU ACCIONISTA O DIRECTOR'
                    style={{ maxWidth: '100%', margin: 'auto' }}>
                    {omodel.titleBVG}
                    <Divider />
                    <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                        <TabPanel header="Sección 1" disabled={accionista == null}>
                            <DatosAccGeneral generic={generic} nextPrev={nextPrev} handleNext={handleNext} handlePrev={handlePrev} permss={permss} cliente={accionista}
                                catalogos={catalogos} toast={toast} seccion="seccion2" nuevoCliente={nuevoCliente} id={accionista?.id} next={handleNext} />
                        </TabPanel>

                        <TabPanel header="Sección 2" disabled={accionista == null || !accionista?.id}>
                            <ConyugueAccionista generic={generic} nextPrev={nextPrev} handleNext={handleNext} handlePrev={handlePrev} permss={permss} cliente={accionista} catalogos={catalogos} toast={toast}
                                seccion="seccion2" nuevoCliente={nuevoCliente} id={accionista?.id} />
                        </TabPanel>

                        <TabPanel header="Sección 3" disabled={accionista == null || !accionista?.id}>
                            <InformacionLaboralAccionista generic={generic} nextPrev={nextPrev} handleNext={handleNext} handlePrev={handlePrev} permss={permss} cliente={accionista} catalogos={catalogos} toast={toast}
                                seccion="seccion3" nuevoCliente={nuevoCliente} id={accionista?.id} urlsPep={urlsPep} />
                        </TabPanel>

                        <TabPanel header="Sección 4" disabled={accionista == null || !accionista?.id}>
                            <FinancieraAccionista generic={generic} nextPrev={nextPrev} next={handleNext} handlePrev={handlePrev} permss={permss} cliente={accionista} catalogos={catalogos} toast={toast}
                                seccion="seccion4" nuevoCliente={nuevoCliente} id={accionista?.id} />
                        </TabPanel>

                        <TabPanel header="Sección 5 (final)" disabled={accionista == null || !accionista?.id}>
                            <AmpliadaAccionsista generic={generic} id={accionista?.id} permss={permss} nextPrev={nextPrev} next={handleNext} catalogos={catalogos} toast={toast}
                                setDialogClientepn={setDialogCliente} seccion="seccion5" tipo='accionistaPnBvg' cancelar={getPerss() === undefined} urls={urls} estado={accionista?.estado_acc}
                                reiniciar={reiniciar} handlePrev={handlePrev} />
                        </TabPanel>

                        {hayPep && <TabPanel header={(pepEstado === 'ENVIADO' || pepEstado === 'FINALIZADO') ? "Formulario PEP Receptado" : "Sección PEP"}
                            disabled={accionista == null || !accionista?.id || ((pepEstado === 'ENVIADO' || pepEstado === 'FINALIZADO') && siCliente)}>
                            <FormPep tipo="accionistaPnBvg" idp={accionista?.id} id={accionista?.pid} version={accionista?.pep_version} permss={permss} toast={toast} urls={urls} reiniciar={reiniciarPep} setDialogClientepn={setDialogCliente} />
                        </TabPanel>}

                        {hayTercero && <TabPanel header={(vinEstado === 'ENVIADO' || vinEstado === 'FINALIZADO') ? "Formulario de vinculación receptado" : "Vinculación con terceros"}
                            disabled={accionista == null || !accionista?.id || ((vinEstado === 'ENVIADO' || vinEstado === 'FINALIZADO') && siCliente)}>
                            <VinculacionBvg generic={generic} nextPrev={nextPrev} next={handleNext} handlePrev={handlePrev} permss={permss} cliente={accionista} catalogos={catalogos} toast={toast}
                                seccion="seccion8" nuevoCliente={nuevoCliente} id={accionista?.vid} idp={accionista?.id} tipo="accionistaDirectorBvg" urls={urlsVin} reiniciar={reiniciarVinculacion} />
                        </TabPanel>}
                    </TabView>
                </Panel>
            }
            {dialogCliente && !siCliente && <><br /><Button label="Regresar" icon="pi pi-replay" onClick={regresar} /></>}
            {dialogInstruccion('Instrucciones', omodel.mensajeBVG)}

            <Dialog visible={dialogSubir} header={"Gestión de anexos: " + accionista?.nombre_completo} modal className="p-fluid modal-ssize" onHide={e => setDialogSubir(false)} style={{ width: '800px' }}>
                <FileBvg generic={generic} tipo="accionistaPnBvg" urls={urls} idp={accionista?.id} toast={toast} permss={permss} estado={accionista?.estado_acc} reiniciar={reiniciar}
                    setDialogSubir={setDialogSubir} opcion={opcion} />
            </Dialog>

            <Dialog visible={dialogPep} header={"Gestión de anexos (PEP): " + accionista?.nombre_completo} modal className="p-fluid modal-ssize" onHide={e => setDialogPep(false)} style={{ width: '800px' }}>
                <FileBvg generic={generic} tipo="accionistaPnBvg" urls={urlsPep} idp={accionista?.pid} toast={toast} permss={permss} estado={accionista?.estado_pep} reiniciar={reiniciar}
                    setDialogSubir={setDialogPep} opcion={opcion} />
            </Dialog>

            <Dialog visible={dialogVinculacion} header={"Gestión de anexos (Vinculación): " + accionista?.nombre_completo} modal className="p-fluid modal-ssize"
                onHide={e => setDialogVinculacion(false)} style={{ width: '800px' }}>
                <FileBvg generic={generic} tipo="accionistaDirectorBvg" urls={urlsVin} idp={accionista?.vid} toast={toast} permss={permss} estado={accionista?.estado_tercero}
                    reiniciar={reiniciar} setDialogSubir={setDialogVinculacion} opcion={opcion} />
            </Dialog>

            <Dialog visible={dialogCancelar} header={"Cancelar formulario: " + accionista?.nombre_completo} modal className="p-fluid modal-ssize" onHide={e => setDialogCancelar(false)} style={{ width: '400px' }}>
                <Cancelar urls="ficha/accionista-pn-bvg/cancelar" generic={generic} toast={toast} permss={permss} id={accionista?.id} respuesta={respuesta} hideDialog={setDialogCancelar} />
            </Dialog>
        </>
    )
}
